import {
  DesktopLayoutStyles,
  DynamicLayoutBlocks,
  minimumUpstreamMessageWidth,
  previewSectionSizes,
  PreviewThemeColors
} from '@MerchantConfigurator/constants';
import {
  closeIconRow,
  getBackgroundColor,
  getContainer,
  getEstimatedTotalLine,
  getHorizontalBars,
  getProductWithOneDescription,
  getProductWithTwoDescriptions,
  getProductWithTwoDescriptionsAndPrice,
  getProductWithTwoDescriptionsAndTotal,
  horizontalLine
} from '@MerchantConfigurator/utils/CommonPreviewBlocks';
import {
  getDesktopPreviewFooter,
  getDesktopPreviewHeader
} from '@MerchantConfigurator/utils/DesktopPreviewBlocks';

export const desktopLayouts = {
  getProductPage: ({ darkMode = false }) => {
    return {
      //main container
      ...getContainer({
        style: {
          flexDirection: 'column',
          width: DesktopLayoutStyles.width,
          height: DesktopLayoutStyles.height,
          marginTop: previewSectionSizes['2xl'],
          border: `2px solid ${getBackgroundColor({
            darkMode,
            backgroundColor: 'backgroundAlternateColor'
          })}`
        }
      }),
      blocks: [
        //header section
        getDesktopPreviewHeader({ darkMode }),
        //main section
        {
          ...getContainer({
            style: {
              width: DesktopLayoutStyles.width,
              height: DesktopLayoutStyles.height,
              backgroundColor: getBackgroundColor({
                darkMode,
                backgroundColor: 'backgroundMainColor'
              }),
              gap: previewSectionSizes['2xl'],
              justifyContent: 'start',
              alignItems: 'start',
              paddingTop: previewSectionSizes['2xl'],
              paddingLeft: DesktopLayoutStyles.padding.left
            }
          }),
          blocks: [
            //left side thumbnail section, just a rectangle block
            {
              ...getContainer({
                style: {
                  width: previewSectionSizes['14xl'],
                  height: previewSectionSizes['14xl'],
                  marginLeft: previewSectionSizes['sm'],
                  backgroundColor: getBackgroundColor({
                    darkMode,
                    backgroundColor: 'componentsColor'
                  })
                }
              })
            },
            //right side details section
            {
              ...getContainer({
                style: {
                  width: previewSectionSizes['16xl'],
                  height: previewSectionSizes['14xl'],
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  gap: previewSectionSizes.lg
                  // paddingTop: previewSectionSizes.lg
                }
              }),
              blocks: [
                // container for product name, price and upstream messaging
                {
                  ...getContainer({
                    style: {
                      width: previewSectionSizes['16xl'],
                      flexDirection: 'column',
                      gap: previewSectionSizes.sm,
                      alignItems: 'flex-start',
                      paddingTop: previewSectionSizes.xl
                    }
                  }),
                  blocks: [
                    //product name bar
                    ...getHorizontalBars({
                      style: {
                        width: previewSectionSizes['4xl'],
                        height: previewSectionSizes.sm,
                        backgroundColor: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'componentsColor'
                        })
                      },
                      number: 1
                    }),
                    //product price bar
                    ...getHorizontalBars({
                      style: {
                        width: previewSectionSizes['2xl'],
                        height: previewSectionSizes.sm,
                        backgroundColor: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'componentsColor'
                        })
                      },
                      number: 1
                    }),
                    //upstream message
                    {
                      type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
                      style: {
                        width: minimumUpstreamMessageWidth,
                        height: previewSectionSizes['6xl'],
                        marginTop: previewSectionSizes.xs
                      }
                    }
                  ]
                },
                //Add to cart button
                {
                  //button container
                  ...getContainer({
                    style: {
                      width: previewSectionSizes['10xl'],
                      height: previewSectionSizes['2xl'],
                      backgroundColor: getBackgroundColor({
                        darkMode,
                        backgroundColor: 'componentsColor'
                      })
                    }
                  }),
                  blocks: [
                    //button label
                    {
                      type: DynamicLayoutBlocks.TEXT,
                      style: {
                        color: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'buttonLabel'
                        })
                      },
                      message: 'preview.addToCart'
                    }
                  ]
                }
              ]
            }
          ]
        },
        //footer section
        getDesktopPreviewFooter({ darkMode })
      ]
    };
  },

  getProductPreviewPage: ({ darkMode = false }) => {
    return {
      //main container
      ...getContainer({
        style: {
          flexDirection: 'column',
          width: DesktopLayoutStyles.width,
          height: DesktopLayoutStyles.height,
          marginTop: previewSectionSizes['2xl'],
          backgroundColor: getBackgroundColor({
            darkMode,
            backgroundColor: 'backgroundAlternateColor'
          })
        }
      }),
      blocks: [
        //main section
        {
          ...getContainer({
            style: {
              width: '504px',
              height: '300px',
              backgroundColor: getBackgroundColor({
                darkMode,
                backgroundColor: 'backgroundMainColor'
              }),
              gap: previewSectionSizes.sm,
              justifyContent: 'center',
              alignItems: 'center',
              paddingLeft: previewSectionSizes.lg,
              paddingBottom: previewSectionSizes.lg
            }
          }),
          blocks: [
            //left side thumbnail section, just a rectangle block
            {
              ...getContainer({
                style: {
                  width: previewSectionSizes['15xl'],
                  height: previewSectionSizes['15xl'],
                  backgroundColor: getBackgroundColor({
                    darkMode,
                    backgroundColor: 'componentsColor'
                  })
                }
              })
            },
            //right side details section
            {
              ...getContainer({
                style: {
                  width: previewSectionSizes['15xl'],
                  height: previewSectionSizes['15xl'],
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-end',
                  gap: previewSectionSizes['3xl'],
                  marginLeft: previewSectionSizes.lg
                }
              }),
              blocks: [
                // container for product name, price and upstream messaging
                {
                  ...getContainer({
                    style: {
                      width: previewSectionSizes['15xl'],
                      flexDirection: 'column',
                      gap: previewSectionSizes.sm,
                      alignItems: 'flex-start',
                      paddingTop: previewSectionSizes.xl
                    }
                  }),
                  blocks: [
                    //product name bar
                    ...getHorizontalBars({
                      style: {
                        width: previewSectionSizes['6xl'],
                        height: previewSectionSizes.sm,
                        backgroundColor: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'componentsColor'
                        })
                      },
                      number: 1
                    }),
                    ...getHorizontalBars({
                      style: {
                        width: previewSectionSizes['4xl'],
                        height: previewSectionSizes.sm,
                        backgroundColor: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'componentsColor'
                        })
                      },
                      number: 1
                    }),
                    //upstream message
                    {
                      type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
                      style: {
                        width: minimumUpstreamMessageWidth,
                        height: previewSectionSizes['6xl'],
                        marginTop: previewSectionSizes.xs
                      }
                    }
                  ]
                },
                //Add to cart button
                {
                  //button container
                  ...getContainer({
                    style: {
                      width: previewSectionSizes['14xl'],
                      height: previewSectionSizes['2xl'],
                      backgroundColor: getBackgroundColor({
                        darkMode,
                        backgroundColor: 'componentsColor'
                      })
                    }
                  }),
                  blocks: [
                    //button label
                    {
                      type: DynamicLayoutBlocks.TEXT,
                      style: {
                        color: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'buttonLabel'
                        })
                      },
                      message: 'preview.addToCart'
                    }
                  ]
                }
              ]
            },
            //close button
            closeIconRow({
              style: {
                position: 'relative',
                top: `-${previewSectionSizes['7xl']}`,
                left: `-${previewSectionSizes.sm}`
              }
            })
          ]
        }
      ]
    };
  },

  getHomePage: ({ darkMode = false }) => ({
    //main container
    ...getContainer({
      style: {
        flexDirection: 'column',
        width: DesktopLayoutStyles.width,
        height: DesktopLayoutStyles.height,
        marginTop: previewSectionSizes['2xl']
      }
    }),
    blocks: [
      //header section
      getDesktopPreviewHeader({ darkMode }),
      //body section
      {
        ...getContainer({
          style: {
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'center',
            width: DesktopLayoutStyles.width,
            height: DesktopLayoutStyles.height,
            backgroundColor: getBackgroundColor({
              darkMode,
              backgroundColor: 'backgroundMainColor'
            }),
            paddingTop: previewSectionSizes['2xl'],
            border: `2px solid ${getBackgroundColor({
              darkMode,
              backgroundColor: 'backgroundAlternateColor'
            })}`
          }
        }),
        blocks: [
          {
            type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
            style: {
              height: previewSectionSizes['6xl'],
              width: '544px',
              marginLeft: previewSectionSizes.lg
            }
          },
          {
            ...getContainer({
              style: {
                justifyContent: 'space-between',
                width: '544px',
                height: previewSectionSizes['15xl'],
                marginLeft: previewSectionSizes.lg
              }
            }),
            blocks: getProductWithTwoDescriptions({ darkMode, number: 3 })
          }
        ]
      },
      //footer section
      getDesktopPreviewFooter({ darkMode })
    ]
  }),

  getCategoryPage: ({ darkMode = false }) => ({
    //main container
    ...getContainer({
      style: {
        flexDirection: 'column',
        width: DesktopLayoutStyles.width,
        height: DesktopLayoutStyles.height,
        marginTop: previewSectionSizes['2xl']
      }
    }),
    blocks: [
      //header section
      getDesktopPreviewHeader({ darkMode }),
      //body section
      {
        ...getContainer({
          style: {
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'center',
            width: DesktopLayoutStyles.width,
            height: DesktopLayoutStyles.height,
            backgroundColor: getBackgroundColor({
              darkMode,
              backgroundColor: 'backgroundMainColor'
            }),
            paddingTop: previewSectionSizes.lg,
            border: `2px solid ${getBackgroundColor({
              darkMode,
              backgroundColor: 'backgroundAlternateColor'
            })}`
          }
        }),
        blocks: [
          {
            type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
            style: {
              height: previewSectionSizes['6xl'],
              width: '100%',
              marginLeft: previewSectionSizes.xl
            }
          },
          {
            ...getContainer({
              style: {
                justifyContent: 'space-between',
                width: '520px',
                height: previewSectionSizes['8xl']
              }
            }),
            blocks: getProductWithOneDescription({ darkMode, number: 4 })
          },
          {
            ...getContainer({
              style: {
                justifyContent: 'space-between',
                width: '520px',
                height: previewSectionSizes['8xl']
              }
            }),
            blocks: getProductWithOneDescription({ darkMode, number: 4 })
          }
        ]
      },
      //footer section
      getDesktopPreviewFooter({ darkMode })
    ]
  }),

  getCartPage: ({ darkMode = false }) => {
    return {
      //main container
      ...getContainer({
        style: {
          flexDirection: 'column',
          width: DesktopLayoutStyles.width,
          height: DesktopLayoutStyles.height,
          marginTop: previewSectionSizes['2xl'],
          border: `2px solid ${getBackgroundColor({
            darkMode,
            backgroundColor: 'backgroundAlternateColor'
          })}`
        }
      }),
      blocks: [
        //header section
        getDesktopPreviewHeader({ darkMode }),
        //main section
        {
          ...getContainer({
            style: {
              width: 'inherit',
              height: DesktopLayoutStyles.height,
              backgroundColor: getBackgroundColor({
                darkMode,
                backgroundColor: 'backgroundMainColor'
              }),
              gap: previewSectionSizes['2xl'],
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              paddingTop: previewSectionSizes['2xl'],
              paddingRight: previewSectionSizes['2xl']
            }
          }),
          blocks: [
            //left side thumbnail section, just a rectangle block
            {
              ...getContainer({
                style: {
                  width: previewSectionSizes['15xl'],
                  height: previewSectionSizes['15xl'],
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  paddingLeft: DesktopLayoutStyles.padding.left
                }
              }),
              blocks: [
                getProductWithTwoDescriptionsAndPrice({
                  darkMode,
                  price: 'right'
                }),
                horizontalLine({ darkMode }),
                getProductWithTwoDescriptionsAndPrice({
                  darkMode,
                  price: 'right'
                }),
                horizontalLine({ darkMode })
              ]
            },
            //right side details section
            {
              ...getContainer({
                style: {
                  height: previewSectionSizes['16xl'],
                  width: previewSectionSizes['16xl'],
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  gap: previewSectionSizes.xs,
                  marginTop: previewSectionSizes.xl,
                  marginLeft: previewSectionSizes.lg
                }
              }),
              blocks: [
                //item 1
                {
                  ...getContainer({
                    style: {
                      justifyContent: 'space-between',
                      gap: previewSectionSizes['8xl'],
                      overflow: 'hidden'
                    }
                  }),
                  blocks: [
                    ...getHorizontalBars({
                      style: {
                        width: previewSectionSizes['4xl'],
                        height: previewSectionSizes.sm,
                        backgroundColor: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'componentsColor'
                        })
                      },
                      number: 1
                    }),
                    ...getHorizontalBars({
                      style: {
                        width: previewSectionSizes['2xl'],
                        height: previewSectionSizes.sm,
                        backgroundColor: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'componentsColor'
                        })
                      },
                      number: 1
                    })
                  ]
                },
                //item 2
                {
                  ...getContainer({
                    style: {
                      justifyContent: 'space-between',
                      gap: previewSectionSizes['8xl'],
                      overflow: 'hidden'
                    }
                  }),
                  blocks: [
                    ...getHorizontalBars({
                      style: {
                        width: previewSectionSizes['4xl'],
                        height: previewSectionSizes.sm,
                        backgroundColor: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'componentsColor'
                        })
                      },
                      number: 1
                    }),
                    ...getHorizontalBars({
                      style: {
                        width: previewSectionSizes['2xl'],
                        height: previewSectionSizes.sm,
                        backgroundColor: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'componentsColor'
                        })
                      },
                      number: 1
                    })
                  ]
                },
                horizontalLine({
                  darkMode,
                  width: '232px'
                }),
                //total
                {
                  ...getContainer({
                    style: {
                      width: '232px',
                      justifyContent: 'space-between',
                      gap: previewSectionSizes['2xl']
                    }
                  }),
                  blocks: [
                    ...getEstimatedTotalLine({
                      darkMode,
                      marginRight: previewSectionSizes.lg
                    })
                  ]
                },
                //upstream message
                {
                  type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
                  style: {
                    width: minimumUpstreamMessageWidth,
                    height: previewSectionSizes['6xl']
                  }
                },
                {
                  //button container
                  ...getContainer({
                    style: {
                      width: '232px',
                      height: previewSectionSizes['3xl'],
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: getBackgroundColor({
                        darkMode,
                        backgroundColor: 'componentsColor'
                      })
                    }
                  }),
                  blocks: [
                    //button label
                    {
                      type: DynamicLayoutBlocks.TEXT,
                      style: {
                        color: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'buttonLabel'
                        })
                      },
                      message: 'preview.button.checkout'
                    }
                  ]
                }
              ]
            }
          ]
        },
        //footer section
        getDesktopPreviewFooter({ darkMode })
      ]
    };
  },

  getCartPreviewPage: ({ darkMode = false }) => ({
    //main container
    ...getContainer({
      style: {
        flexDirection: 'row',
        width: DesktopLayoutStyles.width,
        height: DesktopLayoutStyles.height,
        marginTop: previewSectionSizes['2xl'],
        backgroundColor: darkMode
          ? PreviewThemeColors.dark.backgroundMainColor
          : PreviewThemeColors.light.backgroundAlternateColor
      }
    }),
    blocks: [
      {
        //left panel
        ...getContainer({
          style: {
            width: previewSectionSizes['17xl'],
            height: DesktopLayoutStyles.height,
            backgroundColor: darkMode
              ? PreviewThemeColors.dark.backgroundMainColor
              : PreviewThemeColors.light.backgroundAlternateColor
          }
        })
      },
      {
        //right panel
        ...getContainer({
          style: {
            width: previewSectionSizes['17xl'],
            height: '448px',
            marginRight: previewSectionSizes.xs,
            paddingLeft: previewSectionSizes.lg,
            paddingRight: previewSectionSizes.md,
            flexDirection: 'column',
            alignItems: 'start',
            justifyContent: 'start',
            backgroundColor: darkMode
              ? PreviewThemeColors.dark.backgroundAlternateColor
              : PreviewThemeColors.light.backgroundMainColor
          }
        }),
        blocks: [
          closeIconRow({
            style: {
              width: '248px',
              justifyContent: 'end',
              paddingTop: previewSectionSizes.md
            }
          }),
          ...getHorizontalBars({
            style: {
              width: previewSectionSizes['4xl'],
              height: previewSectionSizes.md,
              backgroundColor: getBackgroundColor({
                darkMode,
                backgroundColor: 'componentsColor'
              })
            },
            number: 1
          }),
          getProductWithTwoDescriptionsAndTotal({ darkMode }),
          horizontalLine({ darkMode, width: '248px' }),
          getProductWithTwoDescriptionsAndTotal({ darkMode }),
          horizontalLine({ darkMode, width: '248px' }),
          {
            ...getContainer({
              style: {
                width: '248px',
                height: previewSectionSizes['2xl'],
                marginTop: previewSectionSizes.md,
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'start'
              }
            }),
            blocks: [
              ...getEstimatedTotalLine({
                darkMode
              })
            ]
          },
          {
            type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
            style: {
              width: minimumUpstreamMessageWidth,
              height: previewSectionSizes['6xl'],
              marginTop: previewSectionSizes.lg
            }
          },
          {
            //button container
            ...getContainer({
              style: {
                backgroundColor: getBackgroundColor({
                  darkMode,
                  backgroundColor: 'componentsColor'
                }),
                marginTop: previewSectionSizes['2xl'],
                marginBottom: previewSectionSizes.sm
              }
            }),
            blocks: [
              //button label
              {
                type: DynamicLayoutBlocks.TEXT,
                style: {
                  width: previewSectionSizes['16xl'],
                  height: previewSectionSizes['3xl'],
                  textAlign: 'center',
                  paddingTop: previewSectionSizes.sm,
                  color: getBackgroundColor({
                    darkMode,
                    backgroundColor: 'buttonLabel'
                  })
                },
                message: 'preview.button.checkout'
              }
            ]
          }
        ]
      }
    ]
  }),

  getCheckoutPage: ({ darkMode = false }) => {
    return {
      //main container
      ...getContainer({
        style: {
          flexDirection: 'column',
          width: DesktopLayoutStyles.width,
          height: DesktopLayoutStyles.height,
          marginTop: previewSectionSizes['2xl'],
          border: `2px solid ${getBackgroundColor({
            darkMode,
            backgroundColor: 'backgroundAlternateColor'
          })}`
        }
      }),
      blocks: [
        //header section
        getDesktopPreviewHeader({ darkMode }),
        //main section
        {
          ...getContainer({
            style: {
              width: DesktopLayoutStyles.width,
              height: DesktopLayoutStyles.height,
              backgroundColor: getBackgroundColor({
                darkMode,
                backgroundColor: 'backgroundMainColor'
              }),
              gap: previewSectionSizes.lg,
              justifyContent: 'center',
              alignItems: 'flex-start',
              paddingTop: previewSectionSizes['2xl']
            }
          }),
          blocks: [
            //left side - checkout fields
            {
              ...getContainer({
                style: {
                  width: previewSectionSizes['17xl'],
                  height: previewSectionSizes['15xl'],
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'space-evenly',
                  paddingLeft: previewSectionSizes['md']
                }
              }),
              blocks: [
                {
                  //name fields
                  ...getContainer({
                    style: {
                      width: previewSectionSizes['16xl'],
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: previewSectionSizes.sm
                    }
                  }),
                  blocks: [
                    //first name
                    {
                      ...getContainer({
                        style: {
                          width: previewSectionSizes['8xl'],
                          height: previewSectionSizes['2xl'],
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: `1px solid ${getBackgroundColor({
                            darkMode,
                            backgroundColor: 'componentsColor'
                          })}`
                        }
                      })
                    },
                    //second name
                    {
                      ...getContainer({
                        style: {
                          width: previewSectionSizes['8xl'],
                          height: previewSectionSizes['2xl'],
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: `1px solid ${getBackgroundColor({
                            darkMode,
                            backgroundColor: 'componentsColor'
                          })}`
                        }
                      })
                    }
                  ]
                },
                //address 1
                {
                  ...getContainer({
                    style: {
                      width: previewSectionSizes['16xl'],
                      height: previewSectionSizes['2xl'],
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: `1px solid ${getBackgroundColor({
                        darkMode,
                        backgroundColor: 'componentsColor'
                      })}`
                    }
                  })
                },
                //address 2
                {
                  ...getContainer({
                    style: {
                      width: previewSectionSizes['16xl'],
                      height: previewSectionSizes['2xl'],
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: `1px solid ${getBackgroundColor({
                        darkMode,
                        backgroundColor: 'componentsColor'
                      })}`
                    }
                  })
                },
                //address 3
                {
                  ...getContainer({
                    style: {
                      width: previewSectionSizes['16xl'],
                      height: previewSectionSizes['2xl'],
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: `1px solid ${getBackgroundColor({
                        darkMode,
                        backgroundColor: 'componentsColor'
                      })}`
                    }
                  })
                },
                //button
                {
                  //button container
                  ...getContainer({
                    style: {
                      width: previewSectionSizes['14xl'],
                      height: previewSectionSizes['3xl'],
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: getBackgroundColor({
                        darkMode,
                        backgroundColor: 'componentsColor'
                      })
                    }
                  }),
                  blocks: [
                    //button label
                    {
                      type: DynamicLayoutBlocks.TEXT,
                      style: {
                        color: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'buttonLabel'
                        })
                      },
                      message: 'preview.button.checkout'
                    }
                  ]
                }
              ]
            },
            //right side details section
            {
              ...getContainer({
                style: {
                  width: previewSectionSizes['16xl'],
                  height: previewSectionSizes['12xl'],
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'space-evenly',
                  gap: previewSectionSizes.xs
                }
              }),
              blocks: [
                //item 1
                {
                  ...getContainer({
                    style: {
                      height: previewSectionSizes.sm,
                      justifyContent: 'space-between',
                      gap: previewSectionSizes['6xl'],
                      overflow: 'hidden',
                      width: previewSectionSizes['14xl']
                    }
                  }),
                  blocks: [
                    ...getHorizontalBars({
                      style: {
                        width: previewSectionSizes['4xl'],
                        height: previewSectionSizes.sm,
                        backgroundColor: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'componentsColor'
                        })
                      },
                      number: 1
                    }),
                    ...getHorizontalBars({
                      style: {
                        width: previewSectionSizes['2xl'],
                        height: previewSectionSizes.sm,
                        backgroundColor: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'componentsColor'
                        })
                      },
                      number: 1
                    })
                  ]
                },
                //item 2
                {
                  ...getContainer({
                    style: {
                      height: previewSectionSizes.sm,
                      justifyContent: 'space-between',
                      gap: previewSectionSizes['6xl'],
                      overflow: 'hidden',
                      width: previewSectionSizes['14xl']
                    }
                  }),
                  blocks: [
                    ...getHorizontalBars({
                      style: {
                        width: previewSectionSizes['4xl'],
                        height: previewSectionSizes.sm,
                        backgroundColor: getBackgroundColor({
                          darkMode,
                          backgroundColor: 'componentsColor'
                        })
                      },
                      number: 1
                    }),
                    ...getHorizontalBars({
                      style: {
                        width: previewSectionSizes['2xl'],
                        height: previewSectionSizes.sm,
                        backgroundColor: darkMode
                          ? PreviewThemeColors.dark.componentsColor
                          : PreviewThemeColors.light.componentsColor
                      },
                      number: 1
                    })
                  ]
                },
                horizontalLine({
                  darkMode,
                  width: previewSectionSizes['14xl']
                }),
                //total
                {
                  ...getContainer({
                    style: {
                      width: previewSectionSizes['14xl'],
                      justifyContent: 'space-between',
                      gap: previewSectionSizes['xl']
                    }
                  }),
                  blocks: [
                    ...getEstimatedTotalLine({
                      darkMode,
                      marginRight: previewSectionSizes.md
                    })
                  ]
                },
                //upstream message
                {
                  type: DynamicLayoutBlocks.UPSTREAMMESSAGE,
                  style: {
                    height: previewSectionSizes['6xl'],
                    marginTop: previewSectionSizes.sm,
                    width: minimumUpstreamMessageWidth
                  }
                }
              ]
            }
          ]
        },
        //footer section
        getDesktopPreviewFooter({ darkMode })
      ]
    };
  }
};
